'use strict';

const Translator = require('./../../../../core/translator');

const FormBuilder = require('./../../builder');
let ElementClass = require('./../../elementClass');

let tpl = require('./template/index.hbs');

FormBuilder.register('textButton', function(config) {
    let self = {};

    self = new ElementClass(config);

    self.render = function($wrap) {
        $wrap.append(tpl({
            'name': self.name,
            'placeholder': Translator.translate(config.placeholder),
            'value': config.value,
            'label': Translator.translate(config.label),
            'message': Translator.translate(config.message),
        }));

        let $input = $wrap.find('input');

        let getValue = function() {
            self.value = $input.val();
            if (typeof config.onSubmit === 'function') {
                config.onSubmit(self.value);
            }
        };

        $wrap.find('.btn-check').on('click', function() {
            getValue();
        });

        $wrap.find('.btn-del').on('click', function() {
            $input.val('');
            getValue();
        });
    };

    self.getData = function() {
        return self.value;
    };

    return self;
});
